import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import GlobalPreferenceTooltip from "shared/containers/GlobalPreferenceTooltip";
import CarotIcon from "shared/components/svgs/carot.svg";
import { isDesktop } from "shared/util/EnvironmentHelpers";
import ProfileMenu from "./ProfileMenu";

import Context from "shared/util/Context";

import {
	selectedOptionOnNavBarEvent,
} from "./analytics";

import "./ProfileButton.scss";

const ProfileButton = ({
	displayName,
	thumbnail,
	isAlist,
	isFlagMod,
	pathname,
}) => {
	const [isMenuOpen, toggleMenu] = useState(false);
	const isDoubleTake = ["/doubletake", "/home"].includes(pathname);

	return (
		<div className="profile-button-container">
			<button
				className={classnames("profile-button", {
					"isOpen": isMenuOpen,
				})}
				onClick={() => {
					toggleMenu(!isMenuOpen);
					selectedOptionOnNavBarEvent("Profile Dropdown");
				}}
			>
				<div className="profile-button-inner-container">
					<div className="profile-button-details">
						<img
							className="profile-button-thumbnail"
							src={thumbnail}
							alt="profile pic"
						/>
						<div
							className={classnames("profile-button-name", {
								"profile-button-name-alist": isAlist,
								"profile-button-name-free": !isAlist,
							})}
						>
							{displayName}
						</div>
						{isAlist && (
							<div className="profile-button-alist">
								A-LIST
							</div>
						)}
					</div>
					<CarotIcon
						className={classnames({
							"profile-button-carot-icon": isMenuOpen,
						})}
					/>
				</div>

			</button>
			{isDesktop && isDoubleTake && Context.has("GLOBAL_PREFERENCES") &&
				<GlobalPreferenceTooltip />
			}
			<ProfileMenu
				isOpen={isMenuOpen}
				isFlagMod={isFlagMod}
				onClose={() => toggleMenu(false)}
			/>
		</div>
	);
};

ProfileButton.propTypes = {
	displayName: PropTypes.string.isRequired,
	thumbnail: PropTypes.string.isRequired,
	isAlist: PropTypes.bool.isRequired,
	isFlagMod: PropTypes.bool.isRequired,
	pathname: PropTypes.string.isRequired,
};

export default ProfileButton;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/ProfileButton.jsx